import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import FormSection from '../../shared/components/FormSection'
import TextInput from '../../shared/components/TextInput'
import TextArea from '../../shared/components/TextArea'

class GeneralFormSection extends Component {

  static propTypes = {
    readOnly: PropTypes.bool,
    show: PropTypes.bool,
    title: PropTypes.string,
    validationObj: PropTypes.object,
  }

  @autobind
  handleResetCoords() {
    alert('TODO')
  }

  render() {
    const {
      validationObj,
      title,
      duration,
      maxParticipants,
      meetingPoint,
      description,
      expireAt,
      show,
      readOnly,
      onChange,
      fieldSpecs
    } = this.props

    return (
      <FormSection
        title="1. Allgemeine Informationen"
        show={show}
      >

        <TextInput
          name="title"
          value={title}
          isValid={validationObj.title}
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.title}
        />

        <TextInput
          name="duration"
          size={4}
          value={duration}
          isValid={validationObj.duration}
          group={{ after: 'Minuten' }}
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.duration}
        />

        <TextInput
          name="maxParticipants"
          size={2}
          value={maxParticipants}
          isValid={validationObj.maxParticipants}
          // placeholder="ohne Einschränkung"
          // helpText="(0 = ohne Einschränkung)"
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.maxParticipants}
        />

        <TextArea
          name="meetingPoint"
          value={meetingPoint}
          isValid={validationObj.meetingPoint}
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.meetingPoint}
        />

        <TextArea
          name="description"
          value={description}
          isValid={validationObj.description}
          maxLength={1000}
          // helpText="Max. 1000 Zeichen inkl. Leerzeichen; Suchwörter verwenden;
          // Struktur: Überblick der Veranstaltung, Ablauf, Alleinstellungsmerkmal"
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.description}
        />

        <TextInput
          name="expireAt"
          size={4}
          value={expireAt}
          isValid={validationObj.expireAt}
          // helpText="Wird hier ein Datum gesetzt, wird das Program an dieem Tag
          // automatisch deaktiviert. 30 Tage vor Ablauf der Frist erhalten Sie eine Erinnerungs-E-Mail."
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.expireAt}
        />

      </FormSection>
    )
  }
}

export { GeneralFormSection as default }



// WEBPACK FOOTER //
// ./src/guided-tour/components/01-GeneralFormSection.js